import { Loader, Text } from "@mantine/core"
import { useTranslation, UseTranslationResponse } from "react-i18next"

import { ContactResponses } from "@tfg/types/endpoints/contacts"

import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/useTraceabilityOperations"
import { useListContactsQuery } from "~/pages/SupplierPortal/TraceabilityRequests/hooks"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { OperationItem } from "~/pages/SupplierPortal/TraceabilityRequests/utils"

export const OperationNotOwner = () => {
  const { t } = useTranslation(["traceability"])
  const { data: contacts, isPending: isLoading } = useListContactsQuery()
  const { isAdmin } = useInformationRequestContext()
  const { operationItem } = useTraceabilityOperations()
  if (isLoading) return <Loader />

  if (!contacts) return null

  const ownerEmail = getOwnerEmail(operationItem, isAdmin, contacts, t)
  return (
    <Text size="sm" w="100%" style={{ textAlign: "center" }}>
      {t("operation.notOwner", {
        email: ownerEmail,
      })}
    </Text>
  )
}

const getOwnerEmail = (
  operationItem: OperationItem,
  isAdmin: boolean,
  contacts: ContactResponses.Contact[],
  t: UseTranslationResponse<["traceability"], undefined>["t"]
) => {
  return (
    (isAdmin
      ? operationItem?.operation?.owner?.email
      : contacts?.find((c) => c.user.id === operationItem.operation?.owner.id)
          ?.user.email) ?? t("operation.unknown")
  )
}
